import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import type { ReactNode } from 'react';
import { DETAIL_GUTTER } from './shared/SectionHeader.js';

const WORKFLOW_ACTIONS = [
  { label: 'More workflows', variant: 'outlined' },
  { label: 'Run ideation on this creative', variant: 'contained' },
] as const;

export function CreativeDetailFooter(): ReactNode {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        px: DETAIL_GUTTER,
        py: 3,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {WORKFLOW_ACTIONS.map((action) => (
        <Tooltip key={action.label} title="Coming soon" placement="top">
          <span>
            <Button variant={action.variant} size="small" disabled>
              {action.label}
            </Button>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
}
